import LojaModel from "./LojaModel";
import ProdutoModel from "./ProdutoModel";
import AppState from "./AppState";

export default class LojaOfertasCacheModel {
    public loja: LojaModel = new LojaModel();
    public ofertas: ProdutoModel[] = [];
    public bemQuerer: ProdutoModel[] = [];

    public static toModel(lojaOferta: any): LojaOfertasCacheModel {
        return {
            loja: AppState.getLojaSelecionada(),
            bemQuerer: lojaOferta.bemQuerer.map((bq: any) => bq as ProdutoModel),
            ofertas: lojaOferta.ofertas.map((of: any) => of as ProdutoModel),
        } as LojaOfertasCacheModel;
    }
}